<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <!-- 页面内容 -->
    <div class="page">
      <div class="img1">
        <img src="@/assets/代表工程/鄂州花湖机场.jpeg" alt="">
        <div class="img1title">鄂州花湖机场</div>
      </div>
      <div class="mode">
        <div class="mode1">
          <div class="modetitle">
            <div class="gang"></div>
            <span>江城子介绍</span>
            <div class="gang"></div>
          </div>
          <div class="modepage">
            <div class="content">
              <div class="modeimg">
                <img src="@/assets/gongsidamen.jpg" alt="">
              </div>
              <div class="text-section">
                <p>湖北江城子建材科技有限公司是一家专业从事聚羧酸系减水剂、混凝土膨胀剂、玻化微珠保温
                  隔热砂浆产品的研发、生产、销售及技术服务的高新技术企业。目前公司已形成年产 3 万吨聚羧
                  酸系减水剂、5 万吨玻化微珠保温砂浆、2 万吨混凝土膨胀剂及特种干混砂浆的生产规模。
                  公司现有职工 150 余人，其中研发及工程技术人员 30 名。公司与国内外著名高校和科研院所建立
                  了产、学、研合作关系，聘请了省内外一批知名专家、教授和专业人士组成专业科研团队，对产品
                  研发进行指导，对高性能聚羧酸系减水剂、混凝土膨胀剂、玻化微珠保温隔热砂浆产品、特种干混
                  砂浆等建筑、工程材料开展了大量研究，为满足客户建设需要、提高产品质量提供了技术保障。
                  公司坚持“诚信立足，创新致远”的企业文化理念，狠抓产品质量和技术服务。系列产品已广泛应
                  用于铁路、公路、水利、市政、桥梁、工业与民用建筑各领域，起到了改善工作性能、提高工程质
                  量、节能环保、可持续发展的良好作用。
                  公司秉承科学发展理念，将与广大客户一起共同实现“中国梦”而不懈努力！</p>
              </div>
              <div class="image-section">
                <div class="image-row">
                  <img src="@/assets/设备照片/WechatIMG29.jpeg" alt="">
                  <img src="@/assets/设备照片/WechatIMG30.jpeg" alt="">
                </div>
                <div class="image-row">
                  <img src="@/assets/设备照片/WechatIMG33.jpeg" alt="">
                  <img src="@/assets/设备照片/WechatIMG34.jpeg" alt="">
                </div>
                <div class="image-row">
                  <img src="@/assets/设备照片/WechatIMG50.jpeg" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'IntroduceIndex',
  components: {
    TopNav,
    FootIndex
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page {
  padding-top: 100px;
}
.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}
.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 0.002rem solid rgb(220, 220, 220);
  padding: 20px;
}

.modeimg {
  width: 80%;
  height: auto;
  overflow: hidden;
  border-radius: 20px;
}

.modeimg img {
  width: 100%;
  height: auto;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.text-section {
  width: 80%;
  text-align: justify;
  margin-bottom: 20px;
}

.text-section p {
  font-size: 18px;
  line-height: 2;
}

.image-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
}

.image-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.image-row img {
  width: 48%;
  border-radius: 10px;
}
</style>
